module.exports = __webpack_public_path__ + "assets/uk.38f1ef6e.svg";